<ng-container *ngIf="readonly; else timePicker">
  <span [id]="id">{{formField.value}}</span>
</ng-container>

<ng-template #timePicker>
  <mat-form-field floatLabel="never">
    <input type="time" matInput [id]="id" [formControl]="formField" class="input-time">
  </mat-form-field>
</ng-template>
